module.exports = __webpack_public_path__ + "assets/media/drift_login_background.cbd143c8.png";